/*
 * cart-validation.js — Cerrajería Santiago
 * ---------------------------------------------------------------------------
 * Hace obligatorios los campos tributarios de /cart y bloquea el submit del
 * formulario de carrito (CartPage-Form) hasta que estén completos y válidos.
 *
 * Siempre obligatorios : Tipo de documento, RUT, Teléfono
 * Obligatorios si Factura : Razón social, Giro, Dirección comercial, Correo
 *
 * Notas de implementación
 * - No se reutiliza <hdt-block-required> del tema: su detección de "campo
 *   lleno" usa el selector literal input[type="text"], que NO matchea
 *   type="tel" ni type="email" (Teléfono y Correo quedarían vacíos para
 *   siempre y el checkout bloqueado). Además no soporta validación de
 *   formato (módulo 11) ni obligatoriedad condicional. Acá seleccionamos
 *   por ID, así que el tipo del input es irrelevante.
 * - formatRut/validateRut están portados desde
 *   sections/form_contact-width-text.liquid:182-215 sin cambios de algoritmo.
 * - Todo va por delegación en document, para sobrevivir a los re-render
 *   parciales que hace el tema al cambiar cantidades en el carrito.
 */
(function () {
  'use strict';

  var I18N = window.hdtDocValidationStrings || {};
  var MSG = {
    required: I18N.required || 'Este campo es obligatorio.',
    rut: I18N.rut || 'El RUT ingresado no es válido.',
    email: I18N.email || 'Ingresa un correo electrónico válido.'
  };

  var WRAP_SELECTOR = '.hdt-doc-tributario';
  var FACTURA_SELECTOR = '.hdt-doc-factura';
  var FACTURA_VALUE = 'Factura';
  var STYLE_ID = 'hdt-doc-validation-styles';

  var FACTURA_IDS = [
    'hdt-doc-razon',
    'hdt-doc-giro',
    'hdt-doc-direccion',
    'hdt-doc-correo'
  ];

  /* -------------------------------------------------------------- estilos */

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.hdt-doc-error{display:block;color:#db1215;font-size:.85em;line-height:1.35;margin-top:.25rem}' +
      '.hdt-doc-error[hidden]{display:none}' +
      '.hdt-doc-tributario [aria-invalid="true"]{border-color:#db1215!important;outline-color:#db1215}';
    (document.head || document.documentElement).appendChild(style);
  }

  /* ------------------------------------------------------ helpers de RUT */
  /* Portados desde sections/form_contact-width-text.liquid:182-215          */

  function formatRut(value) {
    var rut = String(value == null ? '' : value).replace(/[^\dkK]/g, '').toUpperCase();
    return rut.replace(/^(\d{1,2})(\d{3})(\d{3})(\w{1})$/, '$1.$2.$3-$4');
  }

  function validateRut(rutCompleto) {
    if (!rutCompleto || !/^[0-9]{1,2}\.[0-9]{3}\.[0-9]{3}-[0-9kK]{1}$/.test(rutCompleto)) {
      return false;
    }

    var rut = rutCompleto.replace(/\./g, '').replace('-', '');
    var cuerpo = rut.slice(0, -1);
    var dv = rut.slice(-1).toUpperCase();

    var suma = 0;
    var multiplo = 2;

    for (var i = 1; i <= cuerpo.length; i++) {
      suma += multiplo * parseInt(cuerpo.charAt(cuerpo.length - i), 10);
      multiplo = multiplo < 7 ? multiplo + 1 : 2;
    }

    var dvEsperado = 11 - (suma % 11);
    var dvNumero = dv === 'K' ? 10 : dv === '0' ? 11 : parseInt(dv, 10);

    return dvEsperado === dvNumero;
  }

  function validateEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  /* ------------------------------------------------------------- contexto */

  function byId(id) {
    return document.getElementById(id);
  }

  /**
   * Resuelve el estado actual del DOM. Se llama fresco en cada operación
   * para no guardar referencias a nodos que el tema pueda reemplazar.
   */
  function getContext() {
    var wrap = document.querySelector(WRAP_SELECTOR);
    if (!wrap) return null;

    var tipo = byId('hdt-doc-tipo');
    var rut = byId('hdt-doc-rut');
    var telefono = byId('hdt-doc-telefono');
    if (!tipo || !rut || !telefono) return null;

    var formId = tipo.getAttribute('form');
    var form = (formId && byId(formId)) || (tipo.closest && tipo.closest('form'));
    if (!form) return null;

    var facturaFields = [];
    for (var i = 0; i < FACTURA_IDS.length; i++) {
      var el = byId(FACTURA_IDS[i]);
      if (el) facturaFields.push(el);
    }

    var rules = [
      { el: tipo, required: true },
      { el: rut, required: true, check: validateRut, message: MSG.rut },
      { el: telefono, required: true }
    ];

    for (var j = 0; j < facturaFields.length; j++) {
      var field = facturaFields[j];
      var rule = { el: field, required: true, onlyWhenFactura: true };
      if (field.type === 'email') {
        rule.check = validateEmail;
        rule.message = MSG.email;
      }
      rules.push(rule);
    }

    return {
      wrap: wrap,
      form: form,
      tipo: tipo,
      facturaBox: wrap.querySelector(FACTURA_SELECTOR),
      facturaFields: facturaFields,
      rules: rules
    };
  }

  function isFactura(ctx) {
    return ctx.tipo.value === FACTURA_VALUE;
  }

  function ruleApplies(ctx, rule) {
    return !rule.onlyWhenFactura || isFactura(ctx);
  }

  /* -------------------------------------------------------- errores en UI */

  function errorNode(el) {
    var id = el.id + '-error';
    var node = byId(id);
    if (!node) {
      node = document.createElement('span');
      node.id = id;
      node.className = 'hdt-doc-error';
      node.setAttribute('role', 'alert');
      node.hidden = true;
      el.insertAdjacentElement('afterend', node);
    }
    return node;
  }

  function setError(el, message) {
    var node = errorNode(el);
    node.textContent = message;
    node.hidden = false;
    el.setAttribute('aria-invalid', 'true');
    el.setAttribute('aria-describedby', node.id);
  }

  function clearError(el) {
    var node = byId(el.id + '-error');
    if (node) {
      node.textContent = '';
      node.hidden = true;
    }
    el.removeAttribute('aria-invalid');
    el.removeAttribute('aria-describedby');
  }

  /* ----------------------------------------------------------- validación */

  function validateRule(ctx, rule) {
    var el = rule.el;

    if (!ruleApplies(ctx, rule)) {
      clearError(el);
      return true;
    }

    var value = (el.value || '').trim();

    if (rule.required && !value) {
      setError(el, MSG.required);
      return false;
    }

    if (value && rule.check && !rule.check(value)) {
      setError(el, rule.message || MSG.required);
      return false;
    }

    clearError(el);
    return true;
  }

  /** Valida todo y devuelve la primera regla inválida (o null). */
  function validateAll(ctx) {
    var firstInvalid = null;
    for (var i = 0; i < ctx.rules.length; i++) {
      if (!validateRule(ctx, ctx.rules[i]) && !firstInvalid) {
        firstInvalid = ctx.rules[i];
      }
    }
    return firstInvalid;
  }

  /* --------------------------------------------- mostrar/ocultar Factura */

  /**
   * @param {boolean} clearOnHide  Limpia los campos de factura al volver a
   *   Boleta. En la carga inicial va en false, para no borrar valores que
   *   vengan persistidos en los atributos del carrito.
   */
  function syncFactura(ctx, clearOnHide) {
    var show = isFactura(ctx);

    if (ctx.facturaBox) ctx.facturaBox.hidden = !show;

    for (var i = 0; i < ctx.facturaFields.length; i++) {
      var el = ctx.facturaFields[i];
      el.setAttribute('aria-required', show ? 'true' : 'false');

      if (!show) {
        // BUGFIX: los campos de factura siguen asociados al form vía
        // form="CartPage-Form", así que aunque estén hidden se envían igual.
        // Al volver a Boleta hay que vaciarlos o el pedido llega con datos
        // de factura que el cliente ya descartó.
        if (clearOnHide) el.value = '';
        clearError(el);
      }
    }
  }

  function markRequired(ctx) {
    ctx.tipo.setAttribute('aria-required', 'true');
    byId('hdt-doc-rut').setAttribute('aria-required', 'true');
    byId('hdt-doc-telefono').setAttribute('aria-required', 'true');
  }

  /* ------------------------------------------------------------- listeners */

  // Submit: capture en document para correr antes de cualquier handler del
  // tema sobre el form.
  document.addEventListener(
    'submit',
    function (event) {
      var ctx = getContext();
      if (!ctx || event.target !== ctx.form) return;

      // El único type="submit" del form es el botón de checkout, pero si
      // algún día se agrega otro, no lo bloqueamos.
      var submitter = event.submitter;
      if (submitter && submitter.name && submitter.name !== 'checkout') return;

      var invalid = validateAll(ctx);
      if (!invalid) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (invalid.el.scrollIntoView) {
        invalid.el.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      try {
        invalid.el.focus({ preventScroll: true });
      } catch (err) {
        invalid.el.focus();
      }
    },
    true
  );

  // Cambio de tipo de documento.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.id !== 'hdt-doc-tipo') return;

    var ctx = getContext();
    if (!ctx) return;

    syncFactura(ctx, true);
    validateRule(ctx, ctx.rules[0]);
  });

  // Formateo del RUT mientras se escribe + limpieza de errores en vivo.
  document.addEventListener('input', function (event) {
    var target = event.target;
    if (!target || !target.id) return;

    if (target.id === 'hdt-doc-rut') {
      target.value = formatRut(target.value);
    }

    if (target.getAttribute('aria-invalid') !== 'true') return;

    var ctx = getContext();
    if (!ctx) return;

    for (var i = 0; i < ctx.rules.length; i++) {
      if (ctx.rules[i].el === target) {
        validateRule(ctx, ctx.rules[i]);
        break;
      }
    }
  });

  /* ----------------------------------------------------------------- init */

  function init() {
    var ctx = getContext();
    if (!ctx) return; // no estamos en /cart, o el bloque no está renderizado

    injectStyles();
    markRequired(ctx);
    syncFactura(ctx, false);
  }

  function observeRerenders() {
    if (!window.MutationObserver || !document.body) return;

    var observer = new MutationObserver(function () {
      var wrap = document.querySelector(WRAP_SELECTOR);
      if (!wrap || wrap.dataset.hdtDocReady === '1') return;
      wrap.dataset.hdtDocReady = '1';
      init();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    var wrap = document.querySelector(WRAP_SELECTOR);
    if (wrap) wrap.dataset.hdtDocReady = '1';
    init();
    observeRerenders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
